import { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer";
import axios from "../../../axios";
import DeviceModal from "./DeviceModal/DeviceModal";
import classes from "./devices.css";

const dateSort = (rowA, rowB) => {
  const dateA = rowA.createdAt ? new Date(rowA.createdAt).getTime() : 0
  const dateB = rowB.createdAt ? new Date(rowB.createdAt).getTime() : 0
  return dateA - dateB
}

const columns = [
  { name: "Serial Number", selector: "serial", sortable: true, style: { fontSize: "15px" }},
  { 
    name: "Date Added", 
    selector: "createdAt", 
    sortable: true, 
    sortFunction: dateSort,
    style: { fontSize: "14px" },
    format: row => {
      if (!row.createdAt) return 'N/A'
      const date = new Date(row.createdAt)
      return date.toLocaleDateString('en-GB', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
      })
    }
  },
  { name: "Manufacturer", selector: "manufacturer", sortable: true, style: { fontSize: "14px" }},
  { name: "Model", selector: "model", sortable: true, style: { fontSize: "14px" }},
  { name: "Sold to", selector: "soldTo", sortable: true, style: { fontSize: "14px" }},
  { name: "Claimed by", selector: "claimedBy", sortable: true, style: { fontSize: "14px" }},
]

class Devices extends Component {

  state = {
    devices: [],
    selectedDevice: null,
    showDeviceModal: false
  }

  componentDidMount() {
    this.loadDevices();
  }

  loadDevices = () => {
    axios.get("/platforms/devices")
      .then(response => {
        if (response.data && response.data.devices) {
          this.setState({ devices: response.data.devices });
        }
      })
      .catch(err => {
        console.error("Failed to load devices:", err);
      });
  }

  closeModal = () => {
    this.setState({ showDeviceModal: false, selectedDevice: null });
    setTimeout(() => {
      this.loadDevices();
    }, 500);
  }

  render() {
    return (
      <ContentContainer title="Devices">
        <button 
          onClick={() => this.setState({ showDeviceModal: true, selectedDevice: null })} 
          className={classes.addButton}
        >
          Add device
        </button>
        <DataTable
          columns={columns}
          data={this.state.devices}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"createdAt"}
          defaultSortAsc={false}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" }}
          }}
          onRowClicked={(device) => this.setState({ showDeviceModal: true, selectedDevice: device })}
        />

        {this.state.showDeviceModal && (
          <DeviceModal
            shouldShow={this.state.showDeviceModal}
            selectedDevice={this.state.selectedDevice}
            closeModal={() => this.closeModal()}
          />
        )}
      </ContentContainer>
    );
  }
}

export default Devices;
